import { render, staticRenderFns } from "./FieldContent.vue?vue&type=template&id=320f622b&scoped=true"
import script from "./FieldContent.vue?vue&type=script&lang=js"
export * from "./FieldContent.vue?vue&type=script&lang=js"
import style1 from "./FieldContent.vue?vue&type=style&index=1&id=320f622b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320f622b",
  null
  
)

export default component.exports